import { Edit2, Plus, Trash2 } from 'react-feather';

import { AddressData } from '@/MyPage/types/AddressTypes';
import apiToken, {
  handleApiError,
  isSuccess,
} from '@/shared/services/axiosInstance';
import Button from '@/shared/components/UI/Button';
import Modal from '@/shared/components/UI/Modal';

import { UserAddressListProps } from '../types/OrderTypes';

const UserAddressList = ({
  isOpen,
  onClose,
  onAddressSelect,
  onAddAddress,
  onEditAddress,
  onRefreshData,
  userData,
}: UserAddressListProps) => {
  const handleAddressSelect = (address: AddressData) => {
    onAddressSelect(address);
    onClose();
  };

  const deleteAddress = async (addressUuid: string) => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      try {
        const response = await apiToken.delete(
          `/api/v1/user/address/${addressUuid}`,
        );
        if (isSuccess(response.data)) {
          alert('Address deleted successfully.');
          onRefreshData();
        }
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to delete address:', errorMessage);
        alert(errorMessage);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select Address"
      size="lg"
      titleAlign="left"
    >
      <div className="mb-3 border-b border-[#eee] pb-5" />
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-[16px] font-semibold text-[#444]">Address List</h2>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onAddAddress}
          leftIcon={<Plus size={16} color="#95699f" strokeWidth={1.5} />}
          className="px-0 font-normal text-[#95699f]"
        >
          Add Address
        </Button>
      </div>
      <div className="max-h-[400px] overflow-y-auto">
        {userData?.addresses.length === 0 ? (
          <p className="py-8 text-center text-[16px] font-normal text-[#666]">
            No saved addresses.
          </p>
        ) : (
          <div className="flex flex-col gap-3">
            {userData?.addresses.map((address) => (
              <div
                key={address.addressUuid}
                className="cursor-pointer rounded-lg border border-[#ddd] p-5 hover:border-[#95699f] hover:bg-[#f9f7fa]"
              >
                <div className="flex items-center justify-start">
                  <button
                    type="button"
                    className="flex-1 text-left"
                    onClick={() => handleAddressSelect(address)}
                  >
                    <h4 className="text-[16px] font-semibold text-[#95699f]">
                      {address.isDefault ? 'Default' : 'Address'}
                    </h4>
                    <div className="mt-4 flex gap-3 text-[14px] font-normal text-[#666]">
                      <p>{address.addressDetail}</p>
                      {address.postalCode && <p>{address.postalCode}</p>}
                    </div>
                  </button>
                  <div className="flex items-center gap-2">
                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditAddress(address);
                      }}
                      className="h-10 w-10"
                    >
                      <Edit2 size={20} color="#666" strokeWidth={1.5} />
                    </Button>
                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteAddress(address.addressUuid);
                      }}
                      className="h-10 w-10"
                    >
                      <Trash2 size={20} color="#666" strokeWidth={1.5} />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
export default UserAddressList;
